import { useQueryParams } from '@/hooks';
import usePagination from '@/hooks/usePagination';
import { useEffect } from 'react';

const useTransitControlPagination = () => {
  const { setQueryParams, getQueryParam } = useQueryParams();

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize:
        Number(getQueryParam('pageSize')) ||
        Number(localStorage.getItem('transit_control_pageSize')) ||
        50,
    });

  useEffect(() => {
    setQueryParams({
      page: currentPage.toString(),
      pageSize: pageSize.toString(),
    });
  }, [currentPage, pageSize]);

  return {
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange: (newPageSize: number) => {
      localStorage.setItem('transit_control_pageSize', newPageSize.toString());
      handlePageSizeChange(newPageSize);
    },
  };
};

export default useTransitControlPagination;
